module.exports = __webpack_public_path__ + "static/media/el.e7057341.svg";